import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import KanbanStagesAPI from '../../api/kanbanStages';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getStages: _state =>
    [..._state.records].sort((a, b) => a.position - b.position),
  getUIFlags: _state => _state.uiFlags,
  getStageById: _state => id =>
    _state.records.find(r => r.id === Number(id)) || {},
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_KANBAN_STAGE_UI_FLAG, { isFetching: true });
    try {
      const response = await KanbanStagesAPI.get();
      commit(types.SET_KANBAN_STAGES, response.data.payload);
    } finally {
      commit(types.SET_KANBAN_STAGE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, obj) => {
    commit(types.SET_KANBAN_STAGE_UI_FLAG, { isCreating: true });
    try {
      const response = await KanbanStagesAPI.create({ kanban_stage: obj });
      commit(types.ADD_KANBAN_STAGE, response.data);
      return response.data;
    } finally {
      commit(types.SET_KANBAN_STAGE_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...rest }) => {
    commit(types.SET_KANBAN_STAGE_UI_FLAG, { isUpdating: true });
    try {
      const response = await KanbanStagesAPI.update(id, { kanban_stage: rest });
      commit(types.EDIT_KANBAN_STAGE, response.data);
      return response.data;
    } finally {
      commit(types.SET_KANBAN_STAGE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_KANBAN_STAGE_UI_FLAG, { isDeleting: true });
    try {
      await KanbanStagesAPI.delete(id);
      commit(types.DELETE_KANBAN_STAGE, id);
      // as conversas do estágio excluído voltam a ficar SEM estágio (o backend
      // faz nullify); sem isto elas sumiriam do board até um refetch
      commit(types.CLEAR_CONVERSATIONS_KANBAN_STAGE, id, { root: true });
    } finally {
      commit(types.SET_KANBAN_STAGE_UI_FLAG, { isDeleting: false });
    }
  },
  // Reordenar precisa refletir no store (senão a nova ordem some no próximo get)
  reorder: async ({ commit, state: _state }, positions) => {
    const previous = [..._state.records];
    const positionById = new Map(positions.map(p => [p.id, p.position]));
    commit(
      types.SET_KANBAN_STAGES,
      _state.records.map(record => ({
        ...record,
        position: positionById.get(record.id) ?? record.position,
      }))
    );
    try {
      await KanbanStagesAPI.reorder(positions);
    } catch (error) {
      commit(types.SET_KANBAN_STAGES, previous);
      throw error;
    }
  },
};

export const mutations = {
  [types.SET_KANBAN_STAGE_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_KANBAN_STAGES]: MutationHelpers.set,
  [types.ADD_KANBAN_STAGE]: MutationHelpers.create,
  [types.EDIT_KANBAN_STAGE]: MutationHelpers.update,
  [types.DELETE_KANBAN_STAGE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
